import { render, staticRenderFns } from "./CategoryHierarchy.vue?vue&type=template&id=00605034&scoped=true&"
import script from "./CategoryHierarchy.vue?vue&type=script&lang=js&"
export * from "./CategoryHierarchy.vue?vue&type=script&lang=js&"
import style0 from "./CategoryHierarchy.vue?vue&type=style&index=0&id=00605034&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00605034",
  null
  
)

export default component.exports